<template>
  <div class="notification-box-modal">
    <div class="notification-box">
      <slot name="header"></slot>
      <slot name="body"></slot>
      <slot name="footer">
        <div class="notification-box-footer">
          <div class="mfp-close-button button button-black" @click="closeFunctionTrigger()">{{phrases.TEXT_BUTTON_CLOSE }}</div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "modal",
  props: {
    closeFunctionTrigger: function (){}
  },
  computed:{
    ...mapGetters('app', {
      phrases: 'getPhrases'
    }),
  }
}
</script>

<style scoped>

</style>
